import { GetScopeSearchRequest, GetScopeValuesRequest, ScopeItem, TopologyService } from "../../Scopes.types";
import { getSelectedEnvironment, useSubstrateEnvironmentRingTopologyService } from "./useSubstrateEnvironmentRingTopologyService";

import { CentralAdminEntityType } from "Enums/CentralAdminEntityType";
import { Constants } from "Shared/Constants";
import { useScopeSearch } from "../useScopeSearch";
import { useSubstrateForest } from "./useSubstrateForest";
import { useSubstrateRegion } from "./useSubstrateRegion";

export const useSubstrateAccountForestTopologyService = (): TopologyService => {
    const envRingTopologyService = useSubstrateEnvironmentRingTopologyService();
    const { getRegionList } = useSubstrateRegion();
    const { getForestList } = useSubstrateForest();
    const { getScopeSearchResult } = useScopeSearch();

    return {
        getScopeValueOptions: (request: GetScopeValuesRequest): ScopeItem[] | Promise<ScopeItem[]> => {
            const currentScopeTarget = request.currentScopeTarget;
            const environment = getSelectedEnvironment(request.selectedScopesSoFar || []);
            const workload = request.context?.Workload ?? Constants.defaultWorkload;

            switch (currentScopeTarget.ScopeType.toLowerCase()) {
                case "region":
                    return getRegionList(environment, workload);
                case "accountforest":
                    return getForestList(environment, workload, request.selectedScopesSoFar, true);
                default:
                    return envRingTopologyService.getScopeValueOptions(request);
            }
        },
        getScopeSearch: (request: GetScopeSearchRequest): Promise<ScopeItem[]> => {
            const validTargetTypes = [CentralAdminEntityType.Region, CentralAdminEntityType.Forest];
            return getScopeSearchResult(request, validTargetTypes);
        }
    };
};
